import React from "react";

const ModalOneContent = () => {
  return (
    <div className="slideshow">
      <figure>
        {/* Project Details Starts */}
        <figcaption>
          <h3>MSSP Angola</h3>
          <div className="row open-sans-font">
            <div className="col-12 col-sm-6 mb-2">
              <i className="fa fa-file-text-o pr-2"></i>
              <span className="project-label">Projecto </span>:{" "}
              <span className="ft-wt-600 uppercase">Forum</span>
            </div>
            {/* End .col */}

            <div className="col-12 col-sm-6 mb-2">
              <i className="fa fa-user-o pr-2"></i>
              <span className="project-label">Público </span>:{" "}
              <span className="ft-wt-600 uppercase">Todos</span>
            </div>
            {/* End .col */}

           
            {/* End .col */}

            <div className="col-12 col-sm-6 mb-2">
              <i className="fa fa-external-link pr-2"></i>
              <span className="project-label">Abrir </span>:{" "}
              <span className="ft-wt-600 uppercase">
                <a
                  href="https://www.linkedin.com/posts/abiliotandela_mssconference-mssnetwork-managedsecurity-activity-6922943997283823616-wYFx?utm_source=linkedin_share&utm_medium=member_desktop_web"
                  target="_blank"
                  rel="noreferrer"
                >
                  Visualizar
                </a>
              </span>
            </div>
            {/* End .col */}
          </div>
          {/* End .row */}
        </figcaption>
        {/* Project Details Ends */}

        {/*  Main Project Content Starts */}
        <img src="img/projects/project-1.jpg" alt="Portolio" />
        {/* Main Project Content Ends */}
      </figure>
    </div>
    //  End .slideshow
  );
};

export default ModalOneContent;
